(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-payment-badges"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qda-delivery-estimate')) {
    customElements.define('qda-delivery-estimate', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        const minimum = Number.parseInt(this.dataset.minDays, 10);
        const maximum = Number.parseInt(this.dataset.maxDays, 10);
        const output = this.querySelector('[data-delivery-output]');
        if (!output || !Number.isFinite(minimum) || !Number.isFinite(maximum)) return;
        const range = [Math.max(0, minimum), Math.max(0, maximum)].sort((a, b) => a - b);
        const cutoff = String(this.dataset.cutoff || '14:00').match(/^([01]?\d|2[0-3]):([0-5]\d)$/);
        const cutoffMinutes = cutoff ? Number(cutoff[1]) * 60 + Number(cutoff[2]) : 840;
        const localNow = this.getZonedParts(new Date(), this.dataset.timeZone || 'Europe/Paris');
        let baseDate = new Date(Date.UTC(localNow.year, localNow.month - 1, localNow.day));
        const afterCutoff = localNow.hour * 60 + localNow.minute >= cutoffMinutes;
        const businessDays = this.dataset.businessDays !== 'false';
        if (afterCutoff) baseDate.setUTCDate(baseDate.getUTCDate() + 1);
        if (businessDays) {
          while (this.isWeekend(baseDate)) baseDate.setUTCDate(baseDate.getUTCDate() + 1);
        }
        const start = this.addDays(baseDate, range[0], businessDays);
        const end = this.addDays(baseDate, range[1], businessDays);
        const formatter = new Intl.DateTimeFormat(this.dataset.locale || 'fr', {
          day: 'numeric',
          month: 'short',
          timeZone: 'UTC'
        });
        output.textContent = this.formatRange(formatter, start, end);
      }

      formatRange(formatter, start, end) {
        if (typeof formatter.formatRange === 'function') return formatter.formatRange(start, end);
        if (start.getUTCFullYear() === end.getUTCFullYear() && start.getUTCMonth() === end.getUTCMonth()) {
          const month = new Intl.DateTimeFormat(this.dataset.locale || 'fr', {
            month: 'short',
            timeZone: 'UTC'
          }).format(end);
          return `${start.getUTCDate()}–${end.getUTCDate()} ${month}`;
        }
        return `${formatter.format(start)} – ${formatter.format(end)}`;
      }

      addDays(baseDate, days, businessDays) {
        const result = new Date(baseDate.getTime());
        let added = 0;
        while (added < days) {
          result.setUTCDate(result.getUTCDate() + 1);
          if (!businessDays || !this.isWeekend(result)) added += 1;
        }
        return result;
      }

      isWeekend(date) {
        return date.getUTCDay() === 0 || date.getUTCDay() === 6;
      }

      getZonedParts(date, timeZone) {
        const formatter = new Intl.DateTimeFormat('en-CA', {
          timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23'
        });
        return Object.fromEntries(
          formatter.formatToParts(date)
            .filter((part) => part.type !== 'literal')
            .map((part) => [part.type, Number(part.value)])
        );
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["family-pajama-builder"] && !Shopify.designMode) return;
  try {
    class QdaFamilyPajamaBuilder {
    constructor(element) {
      this.element = element;
      if (element.dataset.initialized === 'true') return;
      element.dataset.initialized = 'true';
      this.members = element.querySelector('[data-members]');
      this.template = element.querySelector('[data-member-template]');
      this.addButton = element.querySelector('[data-add-member]');
      this.submitButton = element.querySelector('[data-submit]');
      this.submitLabel = element.querySelector('[data-submit-label]');
      this.submitTotal = element.querySelector('[data-submit-total]');
      this.countLabel = element.querySelector('[data-count]');
      this.totalLabel = element.querySelector('[data-total]');
      this.copyStatus = element.querySelector('[data-copy-status]');
      this.offerTimer = element.querySelector('[data-offer-timer]');
      this.offerCountdown = element.querySelector('[data-offer-countdown]');
      this.offerTimerPrefix = element.querySelector('[data-offer-timer-prefix]');
      this.statusLabel = element.querySelector('[data-status]');
      this.sizeGuideContent = element.querySelector('[data-size-guide-content]');
      this.savingsEl = element.querySelector('[data-savings]');
      this.savingsBadge = element.querySelector('[data-savings-badge]');
      this.savingsDetail = element.querySelector('[data-savings-detail]');
      this.nudgeEl = element.querySelector('[data-nudge]');
      this.showSavings = element.dataset.showSavings === 'true';
      this.savingsBadgeText = element.dataset.savingsBadgeText || '';
      this.savingsDetailText = element.dataset.savingsDetailText || '';
      this.savingsText = element.dataset.savingsText || '';
      this.nudgeText = element.dataset.nudgeText || '';
      const offerOneButton = element.querySelector('.qda-family-builder__offer--one');
      const offerTwoButton = element.querySelector('.qda-family-builder__offer--two');
      this.offerTiers = [
        {
          el: offerOneButton,
          code: offerOneButton ? offerOneButton.dataset.copyCode : '',
          minQty: Number(element.dataset.offerOneMinQty || 0),
          percent: Number(element.dataset.offerOnePercent || 0)
        },
        {
          el: offerTwoButton,
          code: offerTwoButton ? offerTwoButton.dataset.copyCode : '',
          minQty: Number(element.dataset.offerTwoMinQty || 0),
          percent: Number(element.dataset.offerTwoPercent || 0)
        }
      ].filter((tier) => tier.el && tier.code && tier.minQty > 0 && tier.percent > 0)
        .sort((a, b) => a.minQty - b.minQty);
      this.memberSequence = 0;
      this.roleOrder = ['father', 'mother', 'adult', 'child', 'boy', 'girl', 'baby', 'teen', 'dog', 'other'];
      this.roleLabels = Object.fromEntries(this.roleOrder.map((role) => [
        role,
        element.dataset['role' + role.charAt(0).toUpperCase() + role.slice(1)]
      ]));
      this.roleVisibility = Object.fromEntries(this.roleOrder.map((role) => [
        role,
        element.dataset['role' + role.charAt(0).toUpperCase() + role.slice(1) + 'Visible'] !== 'false'
      ]));
      const customAliases = this.parseJson('[data-family-custom-aliases]', {});
      this.customRoleAliases = Object.fromEntries(['father', 'mother', 'adult'].map((role) => [
        role,
        this.parseAliasList(customAliases[role])
      ]));
      this.formatter = new Intl.NumberFormat(element.dataset.locale || 'fr-FR', {
        style: 'currency',
        currency: element.dataset.currency || 'EUR'
      });
      this.optionNames = this.parseJson('[data-family-option-names]', []);
      this.variants = this.parseVariants();
      this.availableRoles = this.roleOrder.filter((role) =>
        this.roleVisibility[role] && this.variants.some((variant) => variant.role === role && variant.available)
      );
      this.addButton.addEventListener('click', () => this.addMember(true));
      this.submitButton.addEventListener('click', () => this.handleSubmit());
      element.querySelectorAll('[data-copy-code]').forEach((button) => {
        button.addEventListener('click', () => this.copyDiscountCode(button));
      });
      element.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-size-guide-open]');
        if (!trigger || !this.sizeGuideContent) return;
        event.preventDefault();
        event.stopPropagation();
        trigger.dispatchEvent(new CustomEvent('tooltip:open', {
          detail: {
            context: 'size-chart',
            content: this.sizeGuideContent.innerHTML
          },
          bubbles: true
        }));
      });
      if (this.availableRoles.length) {
        this.addMember(false);
      } else {
        this.addButton.disabled = true;
        this.statusLabel.textContent = this.element.dataset.soldOut;
      }
      this.setupStickyMobile();
      this.initOfferTimer();
      this.updateSummary();
    }

    initOfferTimer() {
      if (!this.offerTimer || !this.offerCountdown) return;
      this.offerTimerMode = this.offerTimer.dataset.mode;
      const fixedDeadline = this.offerTimerMode === 'fixed' ? Date.parse(this.offerCountdown.dateTime) : null;
      const cutoffMatch = String(this.offerTimer.dataset.cutoff || '').match(/^([01]?\d|2[0-3]):([0-5]\d)$/);
      this.offerTimerDailyCutoff = cutoffMatch ? {
        hour: Number(cutoffMatch[1]),
        minute: Number(cutoffMatch[2])
      } : null;
      if (this.offerTimerMode === 'fixed' && !Number.isFinite(fixedDeadline)) return;
      if (this.offerTimerMode === 'daily' && !this.offerTimerDailyCutoff) return;
      this.offerTimerDeadline = this.offerTimerMode === 'daily'
        ? this.getNextDailyDeadline(new Date(), this.offerTimerDailyCutoff, this.offerTimer.dataset.timeZone)
        : fixedDeadline;
      this.offerTimerVisibilityHandler = () => this.syncOfferTimer();
      document.addEventListener('visibilitychange', this.offerTimerVisibilityHandler);
      this.syncOfferTimer();
    }

    syncOfferTimer() {
      window.clearInterval(this.offerTimerInterval);
      this.offerTimerInterval = null;
      if (!this.element.isConnected) {
        document.removeEventListener('visibilitychange', this.offerTimerVisibilityHandler);
        return;
      }
      if (document.hidden) return;
      if (!this.updateOfferTimer()) return;
      this.offerTimerInterval = window.setInterval(() => this.updateOfferTimer(), 1000);
    }

    updateOfferTimer() {
      if (!this.element.isConnected) {
        window.clearInterval(this.offerTimerInterval);
        document.removeEventListener('visibilitychange', this.offerTimerVisibilityHandler);
        return false;
      }
      let remaining = this.offerTimerDeadline - Date.now();
      if (remaining <= 0 && this.offerTimerMode === 'daily') {
        this.offerTimerDeadline = this.getNextDailyDeadline(
          new Date(),
          this.offerTimerDailyCutoff,
          this.offerTimer.dataset.timeZone
        );
        remaining = this.offerTimerDeadline - Date.now();
      }
      if (remaining <= 0) {
        if (this.offerTimerPrefix) this.offerTimerPrefix.hidden = true;
        this.offerCountdown.textContent = this.offerTimer.dataset.expiredText;
        this.offerTimer.hidden = false;
        return false;
      }

      if (this.offerTimerPrefix) this.offerTimerPrefix.hidden = false;
      const totalSeconds = Math.ceil(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const parts = [];
      if (days > 0) parts.push(`${days} ${this.element.dataset.timerDays}`);
      if (days > 0 || hours > 0) parts.push(`${hours} ${this.element.dataset.timerHours}`);
      parts.push(`${minutes} ${this.element.dataset.timerMinutes}`);
      const secondsText = `${seconds} ${this.element.dataset.timerSeconds}`;
      this.offerCountdown.textContent = `${parts.join(' ')} ${this.element.dataset.timerAnd} ${secondsText}`;
      this.offerTimer.hidden = false;
      return true;
    }

    getNextDailyDeadline(now, cutoff, timeZone) {
      const localNow = this.getTimeZoneParts(now, timeZone);
      let target = {
        year: localNow.year,
        month: localNow.month,
        day: localNow.day,
        hour: cutoff.hour,
        minute: cutoff.minute,
        second: 0
      };
      let deadline = this.zonedTimeToTimestamp(target, timeZone);
      if (deadline <= now.getTime()) {
        const nextDay = new Date(Date.UTC(target.year, target.month - 1, target.day + 1));
        target = {
          ...target,
          year: nextDay.getUTCFullYear(),
          month: nextDay.getUTCMonth() + 1,
          day: nextDay.getUTCDate()
        };
        deadline = this.zonedTimeToTimestamp(target, timeZone);
      }
      return deadline;
    }

    getTimeZoneParts(date, timeZone) {
      const formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });
      return Object.fromEntries(
        formatter.formatToParts(date)
          .filter((part) => part.type !== 'literal')
          .map((part) => [part.type, Number(part.value)])
      );
    }

    zonedTimeToTimestamp(target, timeZone) {
      const targetAsUtc = Date.UTC(
        target.year,
        target.month - 1,
        target.day,
        target.hour,
        target.minute,
        target.second
      );
      let timestamp = targetAsUtc;
      for (let attempt = 0; attempt < 3; attempt += 1) {
        const actual = this.getTimeZoneParts(new Date(timestamp), timeZone);
        const actualAsUtc = Date.UTC(
          actual.year,
          actual.month - 1,
          actual.day,
          actual.hour,
          actual.minute,
          actual.second
        );
        timestamp += targetAsUtc - actualAsUtc;
      }
      return timestamp;
    }

    setupStickyMobile() {
      if (!this.element.classList.contains('qda-family-builder--sticky-mobile')) return;
      this.stickyMedia = window.matchMedia('(max-width: 749px)');
      const updateStickyState = (rect = this.element.getBoundingClientRect()) => {
        const hasReachedBuilder = rect.top < window.innerHeight;
        this.element.classList.toggle(
          'qda-family-builder--sticky-active',
          this.stickyMedia.matches && hasReachedBuilder
        );
      };
      this.stickyObserver = new IntersectionObserver((entries) => {
        updateStickyState(entries[0].boundingClientRect);
      });
      this.stickyObserver.observe(this.element);
      this.stickyMedia.addEventListener('change', () => updateStickyState());
      updateStickyState();
    }

    parseJson(selector, fallback) {
      const source = this.element.querySelector(selector);
      if (!source) return fallback;
      try {
        return JSON.parse(source.textContent);
      } catch (error) {
        this.statusLabel.textContent = this.element.dataset.errorLabel;
        return fallback;
      }
    }

    handleSubmit() {
      const incompleteRows = this.getIncompleteRows();
      if (incompleteRows.length) {
        this.statusLabel.textContent = this.element.dataset.incomplete;
        this.focusRow(incompleteRows[0]);
        return;
      }
      if (this.getSelectedItems().length) {
        this.addToCart();
        return;
      }
      this.focusFirstChoice();
    }

    getMissingField(row) {
      const roleSelect = row.querySelector('[data-role-select]');
      const colorField = row.querySelector('[data-color-field]');
      const colorSelect = row.querySelector('[data-color-select]');
      const variantSelect = row.querySelector('[data-variant-select]');
      if (!roleSelect.value) return roleSelect;
      if (!colorField.hidden && !colorSelect.disabled && !colorSelect.value) return colorSelect;
      if (!variantSelect.disabled && !variantSelect.value) return variantSelect;
      return null;
    }

    getIncompleteRows() {
      return this.getRows().filter((row) => {
        const roleSelect = row.querySelector('[data-role-select]');
        return Boolean(roleSelect.value) && Boolean(this.getMissingField(row));
      });
    }

    focusTarget(target) {
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => target.focus({ preventScroll: true }), 350);
    }

    focusRow(row) {
      this.focusTarget(this.getMissingField(row));
    }

    focusFirstChoice() {
      const rows = this.getRows();
      let target = null;
      rows.some((row) => {
        target = this.getMissingField(row);
        return Boolean(target);
      });
      this.focusTarget(target);
    }

    flashCopyStatus(text) {
      this.copyStatus.textContent = text;
      window.clearTimeout(this._copyStatusTimer);
      this._copyStatusTimer = window.setTimeout(() => {
        this.copyStatus.textContent = '';
      }, 2200);
    }

    async copyDiscountCode(button) {
      const code = button.dataset.copyCode;
      try {
        await navigator.clipboard.writeText(code);
        this.flashCopyStatus(button.dataset.copySuccess);
      } catch (error) {
        const input = document.createElement('input');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        const copied = document.execCommand('copy');
        input.remove();
        this.flashCopyStatus(copied ? button.dataset.copySuccess : this.element.dataset.copyFailed);
      }
    }

    normalize(value) {
      const combiningMarks = new RegExp(
        '[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']',
        'g'
      );
      return String(value || '')
        .normalize('NFD')
        .replace(combiningMarks, '')
        .toLowerCase()
        .trim();
    }

    canonicalize(value) {
      return this.normalize(value)
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    parseAliasList(value) {
      return Array.from(new Set(String(value || '')
        .split(/[,;\n]+/)
        .map((alias) => this.canonicalize(alias))
        .filter(Boolean)));
    }

    matchesAlias(value, aliases) {
      const normalizedValue = this.canonicalize(value);
      return aliases.some((alias) =>
        normalizedValue === alias ||
        normalizedValue.startsWith(alias + ' ') ||
        normalizedValue.endsWith(' ' + alias) ||
        normalizedValue.includes(' ' + alias + ' ')
      );
    }

    optionIndex(aliases) {
      return this.optionNames.findIndex((name) => {
        const normalizedName = this.normalize(name);
        return aliases.some((alias) => normalizedName === alias || normalizedName.includes(alias));
      });
    }

    identifyRole(label) {
      const value = this.normalize(label);
      const localizedRole = ['baby', 'dog', 'teen', 'boy', 'girl', 'child', 'mother', 'father', 'adult'].find((role) => {
        const alias = this.canonicalize(this.roleLabels[role]);
        return alias && this.matchesAlias(value, [alias]);
      });
      if (localizedRole) return localizedRole;
      if (value.includes('bebe') || value.includes('baby') || value.includes('babe')) return 'baby';
      if (value.includes('hund') || value.includes('haustier')) return 'dog';
      if (value.includes('jugendlich')) return 'teen';
      if (value.includes('junge')) return 'boy';
      if (value.includes('madchen')) return 'girl';
      if (value.includes('kind')) return 'child';
      if (this.matchesAlias(value, ['mama', 'mutter', 'frau', 'damen', 'weiblich'])) return 'mother';
      if (this.matchesAlias(value, ['vater', 'mann', 'herren', 'mannlich'])) return 'father';
      if (value.includes('erwachsen')) return 'adult';
      if (value.includes('chien') || value.includes('dog') || value.includes('pet')) return 'dog';
      if (value.includes('ado') || value.includes('teen')) return 'teen';
      if (value.includes('garcon') || value.includes('boy')) return 'boy';
      if (value.includes('fille') || value.includes('girl')) return 'girl';
      if (value.includes('enfant') || value.includes('child') || value.includes('kid')) return 'child';
      if (value.includes('mere') || value.includes('maman') || value.includes('mom') || value.includes('mother') || value.includes('femme') || value.includes('woman') || value.includes('women') || value.includes('female') || /(^|[^a-z0-9])(?:pour\s+)?elle(?=$|[^a-z0-9])/.test(value) || this.matchesAlias(value, this.customRoleAliases.mother)) return 'mother';
      if (value.includes('pere') || value.includes('papa') || value.includes('dad') || value.includes('father') || value.includes('homme') || /(^|[^a-z0-9])(?:man|men|male|(?:pour\s+)?lui)(?=$|[^a-z0-9])/.test(value) || this.matchesAlias(value, this.customRoleAliases.father)) return 'father';
      if (value.includes('adulte') || value.includes('adult') || value.includes('unisexe') || value.includes('unisex') || this.matchesAlias(value, this.customRoleAliases.adult)) return 'adult';
      return 'other';
    }

    cleanCustomAliasAffix(label, role) {
      const original = String(label || '').trim();
      const aliases = this.customRoleAliases[role] || [];
      if (!original || !aliases.length) return original;
      const isExactAlias = (value) => aliases.includes(this.canonicalize(value));
      const segments = original.split(/\s*[-–—:/]\s*/).filter(Boolean);
      if (segments.length > 1 && isExactAlias(segments[0])) segments.shift();
      if (segments.length > 1 && isExactAlias(segments[segments.length - 1])) segments.pop();
      let cleaned = segments.join(' - ').trim();
      const aliasesByLength = [...aliases].sort((a, b) => b.split(' ').length - a.split(' ').length);
      for (const alias of aliasesByLength) {
        const words = cleaned.split(/\s+/).filter(Boolean);
        const aliasLength = alias.split(' ').length;
        if (words.length > aliasLength && this.canonicalize(words.slice(0, aliasLength).join(' ')) === alias) {
          cleaned = words.slice(aliasLength).join(' ');
          break;
        }
        if (words.length > aliasLength && this.canonicalize(words.slice(-aliasLength).join(' ')) === alias) {
          cleaned = words.slice(0, -aliasLength).join(' ');
          break;
        }
      }
      return cleaned.trim() || original;
    }

    cleanSize(label, role) {
      const sepChars = ['-', '–', '—', ':', '/'].join('');
      const roleWords = {
        father: '(?:pour\\s+)?lui|père|pere|papa|dad|father|homme|männlich|mannlich|herren|vater|mann|man|men|male',
        mother: '(?:pour\\s+)?elle|mère|mere|maman|mom|mother|femme|woman|women|female|mutter|mama|frau|damen|weiblich',
        adult: 'adulte|adult|unisexe|unisex|erwachsen(?:e[nrs]?)?',
        child: 'enfant|child|kid|kinder|kind',
        boy: 'garçon|garcon|boy|jungen|junge',
        girl: 'fille|girl|mädchen|madchen',
        baby: '(?:body\\s*)?(?:bébé|bebe|baby|babé|babe)',
        teen: 'ado|adolescent|teenager|teen|jugendliche[nrs]?|jugendlich',
        dog: 'chien|dog|pet|hunde|hund|haustier'
      };
      const localizedLabel = String(this.roleLabels[role] || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const words = [localizedLabel, roleWords[role]].filter(Boolean).join('|');
      let cleaned = String(label || '').trim();
      if (words) {
        const prefix = new RegExp('^(?:' + words + ')\\s*[' + sepChars + ']?\\s*', 'i');
        const suffix = new RegExp('\\s*[' + sepChars + ']?\\s*(?:' + words + ')$', 'i');
        cleaned = cleaned.replace(prefix, '').replace(suffix, '').trim();
      }
      cleaned = this.cleanCustomAliasAffix(cleaned, role);
      return cleaned || String(label || '').trim();
    }

    parseVariants() {
      const variants = this.parseJson('[data-family-variants]', []);
      const roleIndex = this.optionIndex(['pour qui', 'pour', 'personne', 'membre', 'member', 'who', 'fur', 'person', 'familienmitglied', 'mitglied']);
      let sizeIndex = this.optionIndex(['taille', 'size', 'große', 'grosse', 'groesse']);
      const colorIndex = this.optionIndex(['couleur', 'color', 'colour', 'coloris', 'farbe']);
      if (sizeIndex < 0) sizeIndex = Math.max(this.optionNames.length - 1, 0);
      let choiceIndex = colorIndex;
      if (choiceIndex < 0) {
        choiceIndex = this.optionNames.findIndex((name, index) => index !== roleIndex && index !== sizeIndex);
      }
      this.choiceName = choiceIndex >= 0 ? String(this.optionNames[choiceIndex] || '') : '';
      this.choiceLabel = colorIndex >= 0 ? this.element.dataset.colorLabel : this.choiceName;
      this.choicePlaceholder = colorIndex >= 0 ? this.element.dataset.chooseColor : this.element.dataset.chooseOption;

      const parsedVariants = variants.map((variant) => {
        const options = Array.isArray(variant.options)
          ? variant.options
          : [variant.option1, variant.option2, variant.option3].slice(0, this.optionNames.length || 3);
        const sizeSource = options[sizeIndex] || variant.title;
        const roleSource = roleIndex >= 0 ? options[roleIndex] : sizeSource;
        const sizeRole = this.identifyRole(sizeSource);
        let role = sizeRole !== 'other' ? sizeRole : this.identifyRole(roleSource);
        if (role === 'other') {
          const optionWithRole = options.find((value) => this.identifyRole(value) !== 'other');
          if (optionWithRole) role = this.identifyRole(optionWithRole);
        }
        if (role === 'other') role = this.identifyRole(variant.title);
        const color = choiceIndex >= 0 ? String(options[choiceIndex] || '') : '';
        const extraValues = options.filter((value, index) =>
          value && index !== roleIndex && index !== sizeIndex && index !== choiceIndex
        );
        return {
          id: Number(variant.id),
          available: Boolean(variant.available),
          price: Number(variant.price || 0),
          compareAt: Number(variant.compare_at_price || 0),
          role,
          size: this.cleanSize(sizeSource, role),
          color,
          colorLabel: this.cleanSize(color, role),
          style: extraValues.join(' / ')
        };
      });

      const hasIdentifiedRole = parsedVariants.some((variant) => variant.role !== 'other');
      if (!hasIdentifiedRole) {
        parsedVariants.forEach((variant) => {
          variant.role = 'adult';
        });
      }

      return parsedVariants;
    }

    resetSelect(select, placeholderText) {
      select.replaceChildren();
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = placeholderText;
      select.appendChild(placeholder);
      select.disabled = true;
    }

    uniqueValues(values) {
      return Array.from(new Set(values.filter(Boolean)));
    }

    strikeText(text) {
      return Array.from(String(text)).map((char) => char + String.fromCharCode(822)).join('');
    }

    rolePriceLabel(role) {
      const roleVariants = this.variants.filter((variant) =>
        variant.role === role && variant.available && variant.price > 0
      );
      if (!roleVariants.length) return '';
      const prices = roleVariants.map((variant) => variant.price);
      const min = Math.min(...prices);
      const max = Math.max(...prices);
      const text = this.formatter.format(min / 100);
      if (min !== max) return (this.element.dataset.priceFrom || 'dès') + ' ' + text;
      const compareAt = new Set(roleVariants.map((variant) => variant.compareAt)).size === 1
        ? roleVariants[0].compareAt
        : 0;
      return compareAt > min
        ? text + ' ' + this.strikeText(this.formatter.format(compareAt / 100))
        : text;
    }

    addMember(focus) {
      if (!this.template || !this.availableRoles.length) return;
      this.memberSequence += 1;
      const row = this.template.content.firstElementChild.cloneNode(true);
      const roleSelect = row.querySelector('[data-role-select]');
      const colorSelect = row.querySelector('[data-color-select]');
      const variantSelect = row.querySelector('[data-variant-select]');
      const roleLabel = row.querySelector('[data-role-label-element]');
      const colorLabel = row.querySelector('[data-color-label-element]');
      const sizeLabel = row.querySelector('[data-size-label-element]');
      const uniqueId = this.element.id + '-Member-' + this.memberSequence;
      roleSelect.id = uniqueId + '-Role';
      colorSelect.id = uniqueId + '-Color';
      variantSelect.id = uniqueId + '-Size';
      roleLabel.setAttribute('for', roleSelect.id);
      colorLabel.setAttribute('for', colorSelect.id);
      sizeLabel.setAttribute('for', variantSelect.id);
      colorLabel.textContent = this.choiceLabel || this.element.dataset.colorLabel;

      this.availableRoles.forEach((role) => {
        const option = document.createElement('option');
        option.value = role;
        const rolePrice = this.rolePriceLabel(role);
        option.textContent = rolePrice ? this.roleLabels[role] + ' · ' + rolePrice : this.roleLabels[role];
        roleSelect.appendChild(option);
      });

      roleSelect.addEventListener('change', () => {
        this.populateColorsAndSizes(row, roleSelect.value);
        this.statusLabel.textContent = '';
        this.updateMemberLine(row);
        this.updateSummary();
      });
      colorSelect.addEventListener('change', () => {
        this.populateSizes(row, roleSelect.value, colorSelect.value);
        this.statusLabel.textContent = '';
        this.updateMemberLine(row);
        this.updateSummary();
      });
      variantSelect.addEventListener('change', () => {
        this.statusLabel.textContent = '';
        this.updateMemberLine(row);
        this.updateSummary();
      });
      row.querySelector('[data-remove-member]').addEventListener('click', () => {
        row.remove();
        this.renumberMembers();
        this.statusLabel.textContent = '';
        this.updateSummary();
      });

      this.members.appendChild(row);
      this.renumberMembers();
      if (focus) roleSelect.focus();
    }

    populateColorsAndSizes(row, role) {
      const colorField = row.querySelector('[data-color-field]');
      const colorSelect = row.querySelector('[data-color-select]');
      const variantSelect = row.querySelector('[data-variant-select]');
      this.resetSelect(colorSelect, this.choicePlaceholder || this.element.dataset.chooseColor);
      this.resetSelect(variantSelect, this.element.dataset.chooseSize);

      if (!role) {
        colorField.hidden = true;
        return;
      }

      const roleVariants = this.variants.filter((variant) => variant.role === role && variant.available);
      const colors = Array.from(new Map(
        roleVariants
          .filter((variant) => variant.color)
          .map((variant) => [variant.color, variant.colorLabel || variant.color])
      ).entries());

      if (colors.length > 1) {
        colors.forEach(([color, colorLabel]) => {
          const option = document.createElement('option');
          option.value = color;
          option.textContent = colorLabel;
          colorSelect.appendChild(option);
        });
        colorField.hidden = false;
        colorSelect.disabled = false;
        return;
      }

      colorField.hidden = true;
      this.populateSizes(row, role, colors.length ? colors[0][0] : '');
    }

    populateSizes(row, role, color) {
      const select = row.querySelector('[data-variant-select]');
      this.resetSelect(select, this.element.dataset.chooseSize);
      if (!role) return;

      const roleVariants = this.variants.filter((variant) =>
        variant.role === role &&
        (!color || variant.color === color)
      );
      const styles = new Set(roleVariants.map((variant) => variant.style).filter(Boolean));
      const hasAvailable = roleVariants.some((variant) => variant.available);
      const showSizePrices = new Set(
        roleVariants.filter((variant) => variant.available).map((variant) => variant.price)
      ).size > 1;

      roleVariants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.dataset.price = String(variant.price);
        option.dataset.compareAt = String(variant.compareAt || 0);
        const sizeLabel = (styles.size > 1 && variant.style ? variant.style + ' — ' : '') + variant.size;
        option.dataset.label = sizeLabel;
        if (!variant.available) {
          option.textContent = sizeLabel + ' (' + this.element.dataset.soldOut + ')';
        } else if (showSizePrices && variant.price > 0) {
          const sizeCompareAt = variant.compareAt > variant.price
            ? ' ' + this.strikeText(this.formatter.format(variant.compareAt / 100))
            : '';
          option.textContent = sizeLabel + ' · ' + this.formatter.format(variant.price / 100) + sizeCompareAt;
        } else {
          option.textContent = sizeLabel;
        }
        option.disabled = !variant.available;
        select.appendChild(option);
      });
      select.disabled = !hasAvailable;
    }

    renumberMembers() {
      Array.from(this.members.querySelectorAll('[data-member]')).forEach((row, index) => {
        row.querySelector('[data-member-title]').textContent = this.element.dataset.memberPrefix + ' ' + (index + 1);
      });
    }

    getRows() {
      return Array.from(this.members.querySelectorAll('[data-member]'));
    }

    getSelectedItems() {
      const roleCounts = {};
      return this.getRows().flatMap((row) => {
        const role = row.querySelector('[data-role-select]').value;
        const select = row.querySelector('[data-variant-select]');
        if (!role || !select.value) return [];
        roleCounts[role] = (roleCounts[role] || 0) + 1;
        const option = select.options[select.selectedIndex];
        return [{
          id: Number(select.value),
          quantity: 1,
          price: Number(option.dataset.price || 0),
          memberLabel: this.roleLabels[role] + ' ' + roleCounts[role]
        }];
      });
    }

    updateMemberLine(row) {
      const line = row.querySelector('[data-member-line]');
      if (!line) return;
      const roleSelect = row.querySelector('[data-role-select]');
      const variantSelect = row.querySelector('[data-variant-select]');
      const role = roleSelect.value;
      if (!role || !variantSelect.value) {
        line.hidden = true;
        line.replaceChildren();
        return;
      }
      const option = variantSelect.options[variantSelect.selectedIndex];
      const price = Number(option.dataset.price || 0);
      const label = document.createElement('span');
      label.textContent = (this.roleLabels[role] || '') + ' · ' + (option.dataset.label || option.textContent).trim();
      const value = document.createElement('span');
      value.textContent = this.formatter.format(price / 100);
      const compareAt = Number(option.dataset.compareAt || 0);
      if (compareAt > price) {
        const was = document.createElement('s');
        was.className = 'qda-family-builder__member-was';
        was.textContent = this.formatter.format(compareAt / 100);
        value.appendChild(was);
      }
      line.replaceChildren(label, value);
      line.hidden = false;
    }

    updateOfferHighlights(count) {
      this.offerTiers.forEach((tier) => {
        tier.el.classList.toggle('qda-family-builder__offer--active', count >= tier.minQty);
      });
    }

    renderSavingsText(template, values, formatSubtotal = false) {
      return String(template || '').split(/(\{(?:amount|percent|code|subtotal)\})/g).map((part) => {
        const key = part.slice(1, -1);
        if (!/^\{(?:amount|percent|code|subtotal)\}$/.test(part)) {
          return document.createTextNode(part);
        }
        if (key === 'subtotal' && formatSubtotal) {
          const grossEl = document.createElement('span');
          grossEl.className = 'qda-family-builder__savings-gross';
          grossEl.textContent = String(values[key]);
          return grossEl;
        }
        return document.createTextNode(String(values[key]));
      });
    }

    updateSavings(count, subtotal) {
      if (!this.savingsEl || !this.nudgeEl) return;
      if (!this.showSavings || !this.offerTiers.length || count === 0) {
        this.savingsEl.hidden = true;
        this.nudgeEl.hidden = true;
        return;
      }

      const eligible = this.offerTiers.filter((tier) => count >= tier.minQty);
      const active = eligible.length ? eligible[eligible.length - 1] : null;
      const next = this.offerTiers.find((tier) => count < tier.minQty);

      if (active) {
        const grossAmount = this.formatter.format(subtotal / 100);
        const savedAmount = this.formatter.format((subtotal * active.percent) / 10000);
        const savingsValues = {
          subtotal: grossAmount,
          amount: savedAmount,
          percent: active.percent,
          code: active.code
        };
        if (this.savingsBadge) {
          this.savingsBadge.replaceChildren(...this.renderSavingsText(this.savingsBadgeText, savingsValues));
        }
        if (this.savingsDetail) {
          this.savingsDetail.replaceChildren(...this.renderSavingsText(this.savingsDetailText, savingsValues, true));
        }
        this.savingsEl.hidden = false;
      } else {
        this.savingsEl.hidden = true;
      }

      if (next) {
        this.nudgeEl.textContent = this.nudgeText
          .replace('{count}', String(next.minQty - count))
          .replace('{percent}', String(next.percent));
        this.nudgeEl.hidden = false;
      } else {
        this.nudgeEl.hidden = true;
      }
    }

    updateSummary() {
      const items = this.getSelectedItems();
      const count = items.length;
      const subtotal = items.reduce((sum, item) => sum + item.price, 0);
      this.countLabel.textContent = count === 0
        ? this.element.dataset.noSelection
        : count === 1
          ? '1 ' + this.element.dataset.selectedOne
          : count + ' ' + this.element.dataset.selectedMany;
      this.totalLabel.textContent = count
        ? this.element.dataset.estimatedTotal + ' ' + this.formatter.format(subtotal / 100)
        : '';
      this.submitButton.disabled = this.availableRoles.length === 0;
      this.submitButton.toggleAttribute('data-empty', count === 0);
      this.submitLabel.textContent = count === 0
        ? this.element.dataset.compositionPrompt
        : this.element.dataset.addLabel;
      this.submitTotal.textContent = count
        ? '— ' + this.formatter.format(subtotal / 100)
        : '';
      this.updateOfferHighlights(count);
      this.updateSavings(count, subtotal);
    }

    openNativeCart(root, productData) {
      if (
        (window.theme && window.theme.settings && window.theme.settings.cartType === 'page') ||
        !document.querySelector('#CartDrawerForm')
      ) {
        window.location.assign(root + 'cart');
        return;
      }
      this.element.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: productData,
          addToCartBtn: this.submitButton
        },
        bubbles: true
      }));
    }

    async addToCart() {
      const selectedItems = this.getSelectedItems();
      if (!selectedItems.length || this.submitButton.disabled) return;
      this.submitButton.disabled = true;
      this.submitLabel.textContent = this.element.dataset.addingLabel;
      this.submitTotal.textContent = '';
      this.statusLabel.textContent = '';
      this.element.setAttribute('aria-busy', 'true');
      const sessionId = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);

      try {
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: selectedItems.map((item, index) => ({
              id: item.id,
              quantity: 1,
              properties: {
                [this.element.dataset.lineItemMember]: item.memberLabel,
                _qda_family_member: sessionId + '-' + index
              }
            }))
          })
        });
        const responseData = await response.json();
        if (!response.ok) throw new Error('cart_add_failed');
        this.openNativeCart(root, responseData);
      } catch (error) {
        this.statusLabel.textContent = this.element.dataset.errorLabel;
      } finally {
        this.element.removeAttribute('aria-busy');
        this.updateSummary();
      }
    }
  }

  const initializeQdaFamilyPajamaBuilders = (scope = document) => {
    scope.querySelectorAll('[data-family-pajama-builder]').forEach((builder) => {
      new QdaFamilyPajamaBuilder(builder);
    });
  };

  initializeQdaFamilyPajamaBuilders();
  document.addEventListener('shopify:section:load', (event) => {
    initializeQdaFamilyPajamaBuilders(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fomo-stock"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-fomo-stock]:not([data-initialized])').forEach((element) => {
    element.dataset.initialized = 'true';
    const source = element.querySelector('[data-fomo-inventory]');
    const output = element.querySelector('[data-fomo-stock-text]');
    const threshold = Number.parseInt(element.dataset.threshold, 10);
    let inventory = {};
    try {
      inventory = JSON.parse(source ? source.textContent : '{}');
    } catch (error) {
      inventory = {};
    }

    const render = (variantId) => {
      const quantity = Number(inventory[String(variantId)]);
      const visible = Number.isFinite(quantity) && quantity > 0 && quantity <= threshold;
      element.hidden = !visible;
      if (visible && output) {
        output.textContent = String(element.dataset.template || '[count]')
          .replace('[count]', String(quantity));
      }
    };

    const productSection = element.closest('[data-section-type="product"]');
    const selectedVariantId = () => {
      const input = productSection && productSection.querySelector('form[action*="/cart/add"] [name="id"]');
      return input ? input.value : '';
    };

    if (productSection) {
      productSection.addEventListener('variant:change', (event) => {
        render(event.detail && event.detail.variant ? event.detail.variant.id : selectedVariantId());
      });
      productSection.addEventListener('change', () => {
        window.requestAnimationFrame(() => render(selectedVariantId()));
      });
      render(selectedVariantId());
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-template"] && !Shopify.designMode) return;
  try {
    class QdaPromoCode extends HTMLElement {
  connectedCallback() {
    if (this.isInitialized) return;

    this.isInitialized = true;
    this.endTime = this.parseEndTime(this.dataset.endTime);
    this.parisFormatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Paris',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23'
    });
    this.countdownValue = this.querySelector('[data-qda-countdown-value]');
    this.copyButton = this.querySelector('[data-qda-copy-button]');
    this.copyButtonText = this.querySelector('[data-qda-copy-text]');
    this.copyHandler = () => this.copyCode();

    if (this.copyButton) this.copyButton.addEventListener('click', this.copyHandler);

    if (this.countdownValue) {
      this.updateCountdown();
      this.timer = window.setInterval(() => this.updateCountdown(), 1000);
    }
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
    if (this.copyTimeout) window.clearTimeout(this.copyTimeout);
    if (this.copyButton) this.copyButton.removeEventListener('click', this.copyHandler);
    this.isInitialized = false;
  }

  parseEndTime(value) {
    const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec((value || '').trim());
    return match ? { hour: Number(match[1]), minute: Number(match[2]) } : { hour: 0, minute: 0 };
  }

  getParisParts(date) {
    return this.parisFormatter.formatToParts(date).reduce((parts, part) => {
      if (part.type !== 'literal') parts[part.type] = Number(part.value);
      return parts;
    }, {});
  }

  getParisOffset(date) {
    const parts = this.getParisParts(date);
    const roundedTime = Math.floor(date.getTime() / 1000) * 1000;
    return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) - roundedTime;
  }

  parisTimeToUtc(year, month, day, hour, minute) {
    const localTime = Date.UTC(year, month - 1, day, hour, minute, 0);
    let utcTime = localTime;
    for (let index = 0; index < 3; index += 1) {
      utcTime = localTime - this.getParisOffset(new Date(utcTime));
    }
    return utcTime;
  }

  getNextDeadline(nowTime) {
    const parisNow = this.getParisParts(new Date(nowTime));
    let deadline = this.parisTimeToUtc(parisNow.year, parisNow.month, parisNow.day, this.endTime.hour, this.endTime.minute);

    if (deadline <= nowTime) {
      const nextDay = new Date(Date.UTC(parisNow.year, parisNow.month - 1, parisNow.day + 1));
      deadline = this.parisTimeToUtc(nextDay.getUTCFullYear(), nextDay.getUTCMonth() + 1, nextDay.getUTCDate(), this.endTime.hour, this.endTime.minute);
    }
    return deadline;
  }

  updateCountdown() {
    const nowTime = Date.now();
    if (!this.deadline || this.deadline <= nowTime) this.deadline = this.getNextDeadline(nowTime);

    const remaining = Math.max(0, Math.ceil((this.deadline - nowTime) / 1000));
    const hours = Math.floor(remaining / 3600);
    const minutes = Math.floor((remaining % 3600) / 60);
    const seconds = remaining % 60;
    this.countdownValue.textContent = `${hours} h ${minutes} min ${seconds} sec`;
  }

  async copyCode() {
    const code = this.dataset.code || '';
    if (!code || !this.copyButton) return;

    try {
      await navigator.clipboard.writeText(code);
    } catch (error) {
      const input = document.createElement('textarea');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }

    const copiedLabel = this.dataset.copiedLabel || 'Code copié';
    const copyLabel = this.dataset.copyLabel || 'Copier le code';

    if (this.copyTimeout) window.clearTimeout(this.copyTimeout);
    this.copyButton.classList.add('is-copied');
    this.copyButton.setAttribute('aria-label', copiedLabel);
    if (this.copyButtonText) this.copyButtonText.textContent = copiedLabel;

    this.copyTimeout = window.setTimeout(() => {
      this.copyButton.classList.remove('is-copied');
      this.copyButton.setAttribute('aria-label', `${copyLabel} ${code}`);
      if (this.copyButtonText) this.copyButtonText.textContent = code;
      this.copyTimeout = null;
    }, 2000);
  }
}

  if (!customElements.get('qda-promo-code')) {
    customElements.define('qda-promo-code', QdaPromoCode);
  }

  class QdaTieredPromo extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.isInitialized = true;
      this.copyButtons = Array.from(this.querySelectorAll('[data-qda-tiered-copy]'));
      this.countdownValue = this.querySelector('[data-qda-tiered-countdown]');
      this.endTime = this.parseEndTime(this.dataset.endTime);
      this.copyHandlers = new Map();
      this.copyTimers = new Map();
      this.parisFormatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Paris',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });

      this.copyButtons.forEach((button) => {
        const handler = () => this.copyCode(button);
        this.copyHandlers.set(button, handler);
        button.addEventListener('click', handler);
      });

      if (this.countdownValue) {
        this.updateCountdown();
        this.timer = window.setInterval(() => this.updateCountdown(), 1000);
      }
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
      this.copyButtons.forEach((button) => {
        const handler = this.copyHandlers.get(button);
        if (handler) button.removeEventListener('click', handler);
      });
      this.copyTimers.forEach((timer) => window.clearTimeout(timer));
      this.isInitialized = false;
    }

    parseEndTime(value) {
      const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec((value || '').trim());
      return match ? { hour: Number(match[1]), minute: Number(match[2]) } : { hour: 14, minute: 0 };
    }

    getParisParts(date) {
      return this.parisFormatter.formatToParts(date).reduce((parts, part) => {
        if (part.type !== 'literal') parts[part.type] = Number(part.value);
        return parts;
      }, {});
    }

    getParisOffset(date) {
      const parts = this.getParisParts(date);
      const roundedTime = Math.floor(date.getTime() / 1000) * 1000;
      return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) - roundedTime;
    }

    parisTimeToUtc(year, month, day, hour, minute) {
      const localTime = Date.UTC(year, month - 1, day, hour, minute, 0);
      let utcTime = localTime;

      for (let index = 0; index < 3; index += 1) {
        utcTime = localTime - this.getParisOffset(new Date(utcTime));
      }

      return utcTime;
    }

    getNextDeadline(nowTime) {
      const parisNow = this.getParisParts(new Date(nowTime));
      let deadline = this.parisTimeToUtc(
        parisNow.year,
        parisNow.month,
        parisNow.day,
        this.endTime.hour,
        this.endTime.minute
      );

      if (deadline <= nowTime) {
        const nextDay = new Date(Date.UTC(parisNow.year, parisNow.month - 1, parisNow.day + 1));
        deadline = this.parisTimeToUtc(
          nextDay.getUTCFullYear(),
          nextDay.getUTCMonth() + 1,
          nextDay.getUTCDate(),
          this.endTime.hour,
          this.endTime.minute
        );
      }

      return deadline;
    }

    updateCountdown() {
      const nowTime = Date.now();
      if (!this.deadline || this.deadline <= nowTime) this.deadline = this.getNextDeadline(nowTime);

      const remaining = Math.max(0, Math.ceil((this.deadline - nowTime) / 1000));
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      this.countdownValue.textContent = `${hours} h ${minutes} min ${seconds} sec`;
    }

    async copyCode(button) {
      const code = button.dataset.code || '';
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }

      const buttonText = button.querySelector('[data-qda-tiered-copy-text]');
      const copiedLabel = this.dataset.copiedLabel || 'Code copié !';
      const copyLabel = this.dataset.copyLabel || 'Copier le code';
      const previousTimer = this.copyTimers.get(button);

      if (previousTimer) window.clearTimeout(previousTimer);
      button.classList.add('is-copied');
      button.setAttribute('aria-label', copiedLabel);
      if (buttonText) buttonText.textContent = copiedLabel;

      const timer = window.setTimeout(() => {
        button.classList.remove('is-copied');
        button.setAttribute('aria-label', `${copyLabel} ${code}`);
        if (buttonText) buttonText.textContent = code;
        this.copyTimers.delete(button);
      }, 2000);
      this.copyTimers.set(button, timer);
    }
  }

  if (!customElements.get('qda-tiered-promo')) {
    customElements.define('qda-tiered-promo', QdaTieredPromo);
  }

  (function () {
    function qdaTeeinblueSizeGuideInit() {
      var sizeGuide = document.getElementById('qda-teeinblue-size-guide');
      if (!sizeGuide) return;

      function relocate() {
        var title = document.querySelector('.tee-option--size .tee-option__title');
        if (!title || title.contains(sizeGuide)) return;
        title.appendChild(sizeGuide);
        sizeGuide.hidden = false;
      }

      relocate();

      var observer = new MutationObserver(function () {
        relocate();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', qdaTeeinblueSizeGuideInit);
    } else {
      qdaTeeinblueSizeGuideInit();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qda-stories"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('qda-stories')) return;

    class QdaStories extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.closest('.qda-stories');
        this.modal = this.wrapper ? this.wrapper.querySelector('.qda-stories__modal') : null;
        this.modalBody = this.modal ? this.modal.querySelector('.qda-stories__modal-body') : null;
        this.closeBtn = this.modal ? this.modal.querySelector('.qda-stories__modal-close') : null;

        this.addEventListener('click', (event) => {
          var item = event.target.closest('.qda-stories__item');
          if (!item) return;
          this.open(item.getAttribute('data-story-index'));
        });

        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', () => this.close());
        }
        if (this.modal) {
          this.modal.addEventListener('click', (event) => {
            if (event.target === this.modal) this.close();
          });
          this.modal.addEventListener('close', () => this.clear());
        }
      }

      open(index) {
        if (!this.modal || !this.modalBody || !this.wrapper) return;
        var tpl = this.wrapper.querySelector('template[data-story-video="' + index + '"]');
        if (!tpl) return;
        this.modalBody.innerHTML = '';
        this.modalBody.appendChild(tpl.content.cloneNode(true));
        if (typeof this.modal.showModal === 'function') {
          this.modal.showModal();
        } else {
          this.modal.setAttribute('open', '');
        }
        var video = this.modalBody.querySelector('video');
        if (video) {
          video.play().catch(function () {});
        }
      }

      close() {
        if (!this.modal) return;
        if (typeof this.modal.close === 'function') {
          this.modal.close();
        } else {
          this.modal.removeAttribute('open');
          this.clear();
        }
      }

      clear() {
        if (this.modalBody) this.modalBody.innerHTML = '';
      }
    }

    customElements.define('qda-stories', QdaStories);
  })();
  } catch(e) { console.error(e); }
})();

})();
